// prettier-ignore
/* eslint-disable no-irregular-whitespace */
export default function consoleAdvertisement() {
  // tslint:disable-next-line:no-console
  console.log(
    `%c

            ██  ██████  ██ ███    ██     ██    ██ ███████ 
            ██ ██    ██ ██ ████   ██     ██    ██ ██      
            ██ ██    ██ ██ ██ ██  ██     ██    ██ ███████ 
        ██  ██ ██    ██ ██ ██  ██ ██     ██    ██      ██ 
        █████   ██████  ██ ██   ████      ██████  ███████ 

                    https://mycrypto.com/jobs
    `,
    'color: #007896;'
  );
}
